import React, { Fragment, useEffect, useState } from 'react';
import PropTypes, { arrayOf, shape } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import InputField, { isValidPhoneNumber } from 'react-phone-number-input/input';
import validator from 'validator';
import { errorMessages } from '../../../constants/messages';
import AddBankDetails from '../AddClaim/AddBankDetails';
import BankDetailsCard from '../AddClaim/BankDetailsCard';

const StepOne = ({
  loading,
  onConfirm,
  onContinue,
  defaultData,
  bankList,
  currencyList,
  countryList,
  addBankAccount,
  deleteBank,
  policyData,
  bankSelected,
  bankDeleteLoading,
}) => {
  const { register, control, handleSubmit, errors, setValue, getValues, reset } = useForm();
  // const [editContact, setEditContact] = useState(false);
  const [addBankDetails, setAddBankDetails] = useState(false);
  const [showBanks, setSetShowBanks] = useState(true);
  const [num, setNum] = useState(null);
  const [email, setEmail] = useState(null);
  const [bankAccountSelected, setBankAccountSelected] = useState(bankSelected);

  /* eslint-disable */
  const handlePaymentMethod = (e) => {
    if (e.target.value === '0') {
      setSetShowBanks(true);
    } else {
      setSetShowBanks(false);
    }
    setValue('payment_method', e.target.value);
  };

  const setBankAccount = (key, value) => {
    setBankAccountSelected(true);
    setValue(key, value);
  };
  useEffect(() => {
    setBankAccountSelected(bankSelected);
  }, [bankSelected, policyData]);

  useEffect(() => {
    setNum(
      defaultData?.mobile_number
        ? `+${defaultData?.mobile_number.replace('-', '').replace('+', '')}`
        : policyData?.member_details?.phone_number
        ? `+${policyData?.member_details?.phone_number.replace('-', '').replace('+', '')}`
        : '',
    );
    setEmail(defaultData?.email || policyData?.member_details?.email);
    reset({
      email: defaultData?.email || policyData?.member_details?.email,
      mobile_number: defaultData?.mobile_number
        ? `+${defaultData?.mobile_number.replace('-', '').replace('+', '')}`
        : policyData?.member_details?.phone_number
        ? `+${policyData?.member_details?.phone_number.replace('-', '').replace('+', '')}`
        : '',
    });
    // if (defaultData?.payment_method) {
    //   // PAYMENT METHOD WIRE TRANSFER
    //   setSetShowBanks(false);
    // } else {
    //   setSetShowBanks(true);
    // }
  }, []);

  const toggle = () => {
    setAddBankDetails(!addBankDetails);
  };

  const handleSetPayload = (formdata, draft = false) => {
    if (draft) {
      const numValidation = num ? isValidPhoneNumber(num) : false;
      const emailValidation = validator.isEmail(getValues().email);
      onContinue(formdata, numValidation && emailValidation);
    } else {
      onConfirm(formdata);
    }
  };

  const changePatient = (patient_id) => {
    if (patient_id !== '0') {
      const patient = policyData?.dependents?.filter((item) => item?.id === parseInt(patient_id, 10))[0];
      if (patient?.phone_number) {
        setNum(`+${patient?.phone_number.replace('-', '').replace('+', '')}`);
        setValue('mobile_number', `+${patient?.phone_number.replace('-', '').replace('+', '')}`);
      }
      if (patient?.email) {
        setEmail(patient?.email);
        setValue('email', patient?.email);
      }
    } else {
      setNum(`+${policyData?.member_details?.phone_number.replace('-', '').replace('+', '')}`);
      setEmail(policyData?.member_details?.email);
      setValue('mobile_number', `+${policyData?.member_details?.phone_number.replace('-', '').replace('+', '')}`);
      setValue('email', policyData?.member_details?.email);
      console.log(policyData?.member_details);
    }
    setValue('patient', patient_id);
  };

  return (
    <Fragment>
      <Row className="justify-content-between mt-3">
        <Col md="5">
          <Label className="f-mlc-m display-3 tab-title">Personal details</Label>
        </Col>
      </Row>
      <hr />
      <p>Before submitting claim information, please check the following details.</p>
      <Form onSubmit={handleSubmit((values) => handleSetPayload(values, true))} className="mt-3">
        <FormGroup>
          <Row className="justify-content-between mt-3">
            <Input name="claim_id" type="hidden" id="claim_id" value={defaultData?.id} innerRef={register()} />
            <Col md="6">
              <Label for="patient">Who is the patient.</Label>
              <Input
                type="select"
                name="patient"
                id="patient"
                placeholder="Your answer"
                disabled={loading}
                invalid={!!errors.patient}
                innerRef={register()}
                defaultValue={defaultData?.dependent_id}
                onChange={(e) => changePatient(e.target.value)}
              >
                <option key="principal_member" value={0}>
                  {policyData?.member_details?.member_name}
                </option>
                {policyData?.dependents?.map((patient) => (
                  <option key={patient.id} value={patient.id}>
                    {patient.member_name}
                  </option>
                ))}
              </Input>
              {errors.dependent && <p className="invalid-feedback">{errors.patient.message}</p>}
            </Col>
          </Row>

          <h3 className="mt-5">How should we contact you about the claim?</h3>
          <p>This will only be used for this specific claim unless you update it from the profile page.</p>
          <Row className="align-items-start mt-3">
            <Col>
              <Label for="mobile_number">Mobile Number</Label>
              <Controller
                name="mobile_number"
                id="mobile_number"
                control={control}
                innerRef={register({
                  required: num ? (isValidPhoneNumber(num) ? '' : 'Invalid phone number') : 'Phone number required',
                })}
                render={() => (
                  <InputField
                    type="text"
                    // readOnly={!editContact}
                    name="mobile_number"
                    id="mobile_number"
                    placeholder="Phone Number"
                    international
                    withCountryCallingCode
                    className={`form-control ${num ? (!isValidPhoneNumber(num) ? 'is-invalid' : '') : 'is-invalid'}`}
                    disabled={loading}
                    invalid={num ? !isValidPhoneNumber(num) : true}
                    error
                    value={num}
                    onChange={(e) => {
                      setNum(e);
                      setValue('mobile_number', e);
                    }}
                  />
                )}
              />
              <p className="invalid-feedback">
                {`${num ? (isValidPhoneNumber(num) ? '' : 'Invalid phone number') : 'Phone number required'}`}
              </p>
              <p className="phone-info">
                Please enter your phone number prefixed with the country dialing code, without appending any zeroes.
                Eg.(+971 123 1 1234)
              </p>
            </Col>
            <Col>
              <Label for="email">Email Address</Label>
              <Input
                type="email"
                // readOnly={!editContact}
                name="email"
                id="email"
                placeholder="email address"
                disabled={loading}
                invalid={!validator.isEmail(email ?? '')}
                innerRef={register({ required: errorMessages.missingData })}
                onChange={(e) => {
                  setValue('email', e.target.value);
                  setEmail(e.target.value);
                }}
              />
              <p className="invalid-feedback">{`${!validator.isEmail(email ?? '') ? 'Invalid Email' : ''}`}</p>
            </Col>
            {/* <Col>
              <Button
                className="px-3"
                type="button"
                onClick={() => setEditContact(!editContact)}
                color="outline-primary"
              >
                <svg
                  className="mr-0"
                  id="Icon_PencilEdit"
                  data-name="Icon/PencilEdit"
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.519"
                  height="22.519"
                  viewBox="0 0 22.519 22.519"
                >
                  <rect
                    id="Rectangle_95"
                    data-name="Rectangle 95"
                    width="4.03"
                    height="5.689"
                    transform="translate(15.639 2.849) rotate(-45)"
                    fill="#0090da"
                  />
                  <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M5.252,18.107,21.489,2l4.03,4.027L9.4,22.253Zm2.37,5.8-4.03-4.027L3,24.5Z"
                    transform="translate(-3 -1.984)"
                    fill="#007abc"
                  />
                </svg>
              </Button>
            </Col> */}
          </Row>

          <h3 className="mt-5">How would you like to receive your reimbursement?</h3>
          <p>I would like to receive my medical claim(s) reimbursement via: </p>
          <FormGroup tag="fieldset">
            {/* <Row>
              <Col className="d-flex">
                <FormGroup check className="mr-4">
                  <Label check>
                    <Input
                      type="radio"
                      name="payment_method"
                      value="0"
                      disabled={loading}
                      invalid={!!errors.payment_method}
                      defaultChecked={defaultData?.payment_method === 0}
                      innerRef={register({ required: errorMessages.missingData })}
                      onInput={handlePaymentMethod}
                    />
                    Wire Transfer
                  </Label>
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="payment_method"
                      value="1"
                      disabled={loading}
                      invalid={!!errors.payment_method}
                      defaultChecked={defaultData?.payment_method === 1}
                      innerRef={register({ required: errorMessages.missingData })}
                      onInput={handlePaymentMethod}
                    />
                    Cheque
                  </Label>
                </FormGroup>
              </Col>
            </Row> */}
          </FormGroup>
          {/* <Row>
            <Col>
              <h2>Bank Details</h2>
            </Col>
            <Col className="text-right text-primary font-weight-bold">
              <a onClick={toggle}>+ Add Bank Details</a>
            </Col>
          </Row>
          <Row>
            {policyData?.member_details?.bank_accounts.map((x) => (
              <BankDetailsCard
                register={register}
                setValue={setValue}
                key={x.id}
                data={x}
                deleteBank={deleteBank}
                defaultChecked={x?.id === defaultData?.bank_id}
              />
            ))}
          </Row> */}
          {showBanks ? (
            <div>
              <Row>
                <Col>
                  <h3>Bank Details</h3>
                </Col>
                <Col className="text-right text-primary font-weight-bold">
                  <a onClick={toggle}>+ Add Bank Details</a>
                </Col>
              </Row>
              <Row>
                <p className="mt-1 ml-3">
                  (Note: If the country of Bank you choose is United Arab Emirates, Oman, Bahrain, Qatar or Kuwait
                  please choose a bank account having IBAN number.)
                </p>
              </Row>
              <Row>
                {policyData?.member_details?.bank_accounts.map((x) => (
                  <BankDetailsCard
                    register={register}
                    setValue={setBankAccount}
                    key={x.id}
                    data={x}
                    defaultChecked={
                      defaultData?.bank_id
                        ? x?.id?.toString() === defaultData?.bank_id?.toString()
                        : x?.id?.toString() === policyData?.member_details?.bank_id?.toString()
                    }
                    deleteBank={deleteBank}
                    loading={bankDeleteLoading}
                  />
                ))}
                {errors.bank_id && <p className="invalid-feedback">Please Choose a bank</p>}
              </Row>
              {!bankAccountSelected && (
                <Col className="text-right">
                  <p style={{ color: 'red' }}> Please choose a bank account</p>
                </Col>
              )}
            </div>
          ) : (
            <Row>
              <Col>
                <FormGroup className="form-label-group">
                  <Input
                    type="payment_to"
                    readOnly
                    defaultValue={policyData?.member_details?.member_name}
                    name="payment_to"
                    id="payment_to"
                    placeholder="payment_to address"
                    disabled={loading}
                    invalid={!!errors.payment_to}
                    innerRef={register({ required: errorMessages.missingData })}
                    onChange={(e) => setValue('payment_to', e.target.value)}
                  />
                  <Label for="payment_to">Paid To</Label>
                  {errors.dependent && <p className="invalid-feedback">{errors.email.message}</p>}
                </FormGroup>
              </Col>
            </Row>
          )}
          <Row>
            <Col className="text-right">
              <Button color="outline-primary" className="mr-3">
                Continue
              </Button>
            </Col>
          </Row>
        </FormGroup>
      </Form>
      {addBankDetails && (
        <AddBankDetails
          toggle={toggle}
          isOpen={addBankDetails}
          bankList={bankList}
          currencyList={currencyList}
          countryList={countryList}
          onConfirm={addBankAccount}
          loading={loading}
          user={policyData?.member_details}
        />
      )}
    </Fragment>
  );
};

StepOne.propTypes = {
  policyData: shape({
    dependents: arrayOf(
      shape({
        name: PropTypes.string,
        id: PropTypes.number,
        code: PropTypes.string,
      }),
    ),
    user: shape({
      email: PropTypes.string,
      phone_number: PropTypes.string,
      bank_accounts: PropTypes.arrayOf({}),
    }),
  }).isRequired,
  defaultData: PropTypes.shape({
    email: PropTypes.string,
    mobile_number: PropTypes.string,
    dependent_id: PropTypes.number,
    payment_method: PropTypes.number,
    bank_id: PropTypes.number,
    id: PropTypes.number,
  }),
  onConfirm: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  bankList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currencyList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  countryList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  deleteBank: PropTypes.func.isRequired,
  addBankAccount: PropTypes.func.isRequired,
  bankSelected: PropTypes.bool.isRequired,
  bankDeleteLoading: PropTypes.bool,
};

StepOne.defaultProps = {
  loading: false,
  defaultData: {},
  bankDeleteLoading: false,
};

export default withRouter(StepOne);
